import React from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import * as COMMON from '../../utils/common';
import axios from 'axios';
import * as API from '../../utils/api'

import './index.css';

export default function ForgetPasswordView(){

    const backToMain = () => {
        COMMON.removeLocalStorage('forgetPassword');
        window.open('/', "_self");
    }

    const sumbit = (e)=>{
        e.preventDefault();
        var body = {
            username: e.target.username.value
        };
        axios.post(API.FORGET_PASSWORD_API, body)
        .then((data)=>{
            backToMain();
        })
        .catch((error)=>{
            backToMain();
        })
    }

    return (
        <div>
            <p className="forgetText">Forget Password ?</p>
            <form
                className="rightforgetDiv"
                id="main-forget"
                onSubmit={sumbit}
            >
                <InputGroup className="mb-3">
                    <FormControl
                        id="username"
                        placeholder="Username"
                        aria-label="username"
                        aria-describedby="basic-addon1"
                    />
                </InputGroup>
                <input type="submit" value="submit" className="forgetButton" />
            </form>
        </div>
    )
}